import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-onboard-desk",
  "use": "icon-leo-onboard-desk-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-onboard-desk\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<path d=\"M192 640h640v192H192z\" /><path d=\"M256 640V384l256-160 256 160v256H256z\" /><rect x=\"448\" y=\"480\" width=\"128\" height=\"160\" fill=\"#fff\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-onboard-desk.svg
// module id = D5b2
// module chunks = 477